import {
  ensureMessengerNotificationPermission,
  isMessengerBackgroundNotificationSupported,
} from "@/utils/messengerNotifications";

/** Браузер умеет системные уведомления (на iPhone в обычной вкладке — нет). */
export const isNotificationSupported = () =>
  isMessengerBackgroundNotificationSupported();

/** "default" | "granted" | "denied" | "unsupported" */
export const getPermission = () =>
  isNotificationSupported() ? Notification.permission : "unsupported";

/**
 * Системный запрос разрешения. Вызывать строго в обработчике нажатия.
 * @returns {Promise<"default"|"granted"|"denied"|"unsupported">}
 */
export const requestPermission = () => ensureMessengerNotificationPermission();
